// extracted by mini-css-extract-plugin
export default {"gradeContainer":"styles_gradeContainer__vwfky"};